module.exports = __webpack_public_path__ + "img/Memberkit-4-es.98175141.png";